<template>
  <div :class="params.class?params.class:'reg-checkbox'">
      <input :name="params.name" type="hidden" :value="params.valUnCheck">
      <div class="reg-checkbox" :class="params.error?'error':''">
        <input :id="params.id" :name="params.name" type="checkbox" :value="params.valCheck" :checked="params.checked === 'Y'">
        <label :for="params.id" v-html="params.text+'<i></i>'"></label>
      </div>
    </div>
</template>

<script>
export default {
  name: "order_checkbox",
  props:['params']
}
</script>

<style scoped>
.reg-checkbox.error {
  border: solid 1px #f00;
}

</style>